import React from 'react';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import MetricsCard from './components/MetricsCard';
import ActivityFeed from './components/ActivityFeed';
import CampaignStatus from './components/CampaignStatus';
import QuickActions from './components/QuickActions';
import MediaMonitoring from './components/MediaMonitoring';
import UpcomingDeadlines from './components/UpcomingDeadlines';

const Dashboard = () => {
  const metricsData = [
    {
      title: 'Press Release Views',
      value: '12,847',
      change: '+15.3%',
      changeType: 'positive',
      icon: 'Eye',
      iconColor: 'bg-primary'
    },
    {
      title: 'Email Open Rate',
      value: '68.2%',
      change: '+5.7%',
      changeType: 'positive',
      icon: 'Mail',
      iconColor: 'bg-success'
    },
    {
      title: 'Media Engagement',
      value: '2,341',
      change: '+23.1%',
      changeType: 'positive',
      icon: 'Users',
      iconColor: 'bg-accent'
    },
    {
      title: 'Active Campaigns',
      value: '18',
      change: '-2',
      changeType: 'negative',
      icon: 'Briefcase',
      iconColor: 'bg-secondary'
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <Breadcrumb />
          
          {/* Welcome Section */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Welcome back, John! 👋
            </h1>
            <p className="text-muted-foreground">
              Here's what's happening with your PR campaigns today.
            </p>
          </div>

          {/* Metrics Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {metricsData?.map((metric, index) => (
              <MetricsCard
                key={index}
                title={metric?.title}
                value={metric?.value}
                change={metric?.change}
                changeType={metric?.changeType}
                icon={metric?.icon}
                iconColor={metric?.iconColor}
              />
            ))}
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
            {/* Left Column - Activity Feed */}
            <div className="lg:col-span-2 space-y-8">
              <ActivityFeed />
              <MediaMonitoring />
            </div>

            {/* Right Column - Campaign Status & Quick Actions */}
            <div className="space-y-8">
              <QuickActions />
              <CampaignStatus />
              <UpcomingDeadlines />
            </div>
          </div>

          {/* Bottom Section - Additional Insights */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-card border border-border rounded-lg p-6">
              <h2 className="text-lg font-semibold text-foreground mb-4">This Week's Highlights</h2>
              <div className="space-y-4">
                <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                  <div>
                    <p className="text-sm font-medium text-foreground">Top Performing Release</p>
                    <p className="text-xs text-muted-foreground">"The Digital Revolution" - 3.2K views</p>
                  </div>
                  <div className="text-success text-sm font-medium">+127%</div>
                </div>
                <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                  <div>
                    <p className="text-sm font-medium text-foreground">Best Email Campaign</p>
                    <p className="text-xs text-muted-foreground">Mystery Launch - 72% open rate</p>
                  </div>
                  <div className="text-success text-sm font-medium">+18%</div>
                </div>
                <div className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
                  <div>
                    <p className="text-sm font-medium text-foreground">New Media Contacts</p>
                    <p className="text-xs text-muted-foreground">15 contacts added this week</p>
                  </div>
                  <div className="text-primary text-sm font-medium">+15</div>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border rounded-lg p-6">
              <h2 className="text-lg font-semibold text-foreground mb-4">Quick Stats</h2>
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center p-4 bg-muted/50 rounded-lg">
                  <div className="text-xl font-bold text-foreground mb-1">156</div>
                  <div className="text-xs text-muted-foreground">Total Press Kits</div>
                </div>
                <div className="text-center p-4 bg-muted/50 rounded-lg">
                  <div className="text-xl font-bold text-foreground mb-1">2,847</div>
                  <div className="text-xs text-muted-foreground">Media Contacts</div>
                </div>
                <div className="text-center p-4 bg-muted/50 rounded-lg">
                  <div className="text-xl font-bold text-foreground mb-1">89</div>
                  <div className="text-xs text-muted-foreground">Active Authors</div>
                </div>
                <div className="text-center p-4 bg-muted/50 rounded-lg">
                  <div className="text-xl font-bold text-foreground mb-1">342</div>
                  <div className="text-xs text-muted-foreground">Sent Emails</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;